import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilityService } from 'src/app/services/utility.service';
import { ConfigService } from 'src/app/services/config-service/config-service';
import { Recupero, StatoRecupero } from 'src/app/models/recupero';
import { RecuperoEditorComponent } from '../recupero-editor/recupero-editor.component';
import { RecuperoService } from 'src/app/services/recupero-service';
import { EventsService } from 'src/app/services/eventsService';

@Component({
    selector: 'app-recupero-viewer',
    templateUrl: './recupero-viewer.component.html',
    styleUrls: ['./recupero-viewer.component.scss'],
    standalone: false
})
export class RecuperoViewerComponent implements OnInit {
[x: string]: any;
  @Input() recupero: Recupero;
  @Input() statoRecupero: string;

  constructor(
    private utilityService: UtilityService,
    private translateService: TranslateService,
    private recuperoService: RecuperoService,
    public configService: ConfigService,
    private events: EventsService,
  ) {
  }

  ngOnInit() {
    console.log('recupero', this.recupero);
    console.log('statoRecupero', this.statoRecupero);
  }


  async convalida() {
    // deve passare l'anno corrente e il docente per prefiltrare le ad da proporre // todo
    const modalResp = await this.utilityService.showModal(RecuperoEditorComponent, {recupero: this.recupero});
    if (modalResp.data) {
      const rec = modalResp.data.recupero;
      console.log('recupero', modalResp.data.recupero);
      // valorizza i campi da aggiornare
      rec.idArConvalida = rec.insegnamentoConvalida.id.split(':')[1];
      rec.idDocenteConvalida = rec.docenteConvalida.id;
      rec.stato = StatoRecupero.APPROVATO;
      this.salvaRecupero(rec);
    }
  }

  async respingi() {
    this.recupero.stato = StatoRecupero.RESPINTO;
    this.salvaRecupero(this.recupero);
  }

  // async modifica() {
  //   // deve passare i dati del recupero as is // todo
  //   const modalResp = await this.utilityService.showModal(RecuperoEditorComponent, {recupero: this.recupero});
  //   if (modalResp.data) {
  //     console.log('recupero', modalResp.data.recupero);
  //     this.salvaRecupero(modalResp.data.recupero);
  //   }
  // }

  // async completa() {
  //   console.log('recupero', this.recupero);
  //   this.recupero.stato = StatoRecupero.COMPLETATO;
  //   this.salvaRecupero(this.recupero);
  // }

  salvaRecupero(recupero: Recupero) {
    console.log('recupero', recupero);
    this.recuperoService.salvaRecupero(recupero).subscribe(r => {
      console.log(r);
      this.events.recuperiUpdated.next();
    });
  }

//   ngOnChanges(changes: SimpleChanges): void {
//     if (changes['rilevazione']) {
//       if (this.translateService.currentLang === 'it') {
//         this.dateOpts = { locale: itLocale };
//       }

//       this.timeFormatted = format(new Date(this.rilevazione.istanteCreazione), 'H:mm', this.dateOpts );
//       this.dayFormatted = format(new Date(this.rilevazione.istanteCreazione), 'EEE', this.dateOpts );
//       this.dateFormatted = format(new Date(this.rilevazione.istanteCreazione), 'd MMMM y', this.dateOpts );
//     }
// }

  // showHint(mess, mess2: string = null, event = null) {
  //   this.utilityService.showHintNoProp(mess, mess2, event);
  // }

}
